import { formDataToObject, ISharedConfig, setDialog, setSnackbar } from '@shared/library';
import axios, { AxiosError } from 'axios';
import React from 'react';
import { excludedWfmPlanningColumns } from '../Planning';
import config from '../../../../../config';
import { interventionColumns } from '../../static';
//#region COMPONENTS 
import GestDataGridPro from '@shared/library/dist/components/gest/GestDataGrid/GestDataGridPro';
import GestSaveButton from '@shared/library/dist/components/gest/GestInputs/button/save/GestSaveButton';
import GestTextArea from '@shared/library/dist/components/gest/GestInputs/text area/GestTextArea';
//#endregion
//#region MODELS
import { IIntervention } from '../../_models/Intervention';
import { IList } from '../../_models/List';
import { IPlan } from '../../_models/Plan';
import { ICreatePlanFormProps } from '../CreatPlanForm/CreatePlanForm';
//#endregion
//CONTEXTS

export interface IPlanningCommonFormProps {
    config: ISharedConfig,
    lang?: any;
    plan: IIntervention[];
    existingPlans: IPlan[];
    onSuccess: () => void;
}

interface ICreateImportListProps extends ICreatePlanFormProps {
    interventions: IIntervention[],
    lists: IList[];
}

const CreateImportListForm = (props: ICreateImportListProps) => {
    //STATES
    const [loading, setLoading] = React.useState(false);
    const form = React.useRef<HTMLFormElement>(null);

    //METHODS
    const createInterventionsListAPI = (event: React.SubmitEvent<HTMLFormElement>) => {
        event.preventDefault();
        const Listname = formDataToObject<{ listname: string; }>(form.current)?.listname;
        const Interventions = props.interventions;

        if (Listname && Interventions?.length) {
            setLoading(true);
            return axios.post(`${config.api.internal}/WFM/List/Import`, { Listname, Interventions }, { withCredentials: true })
                .then(() => {
                    props.onSuccess();
                    setSnackbar(props.config, { message: props.lang.successfully_imported, severity: 'success' });
                    setDialog(props.config);
                })
                .catch((err: AxiosError) => {
                    console.error(err);
                    setSnackbar(props.config, { message: "Errore durante l'importazione della lista di interventi", severity: 'error' });
                })
                .finally(() => setLoading(false));
        }
    };

    return <form ref={form} onSubmit={createInterventionsListAPI}>
        <GestTextArea
            name="listname"
            label={props.lang.list_name}
            value={`${props.lang.interventions_list} ${props.lists.length + 1}`}
            style={{ width: 240 }}
            required={true}
        />

        <GestDataGridPro
            columns={interventionColumns({ ...props, plans: props.existingPlans, excluded: excludedWfmPlanningColumns })}
            rows={props.interventions}
            w="70vw"
            columnVisibilityModel={props.hiddenColumns}
        />

        <GestSaveButton alignment='right' label={props.lang.save} {...{ loading }} submit />
    </form>;
};
export default React.memo(CreateImportListForm);